(function (window, angular) {
    'use strict';

    angular.module('app')
        .controller('wysiwygImageUploadController', wysiwygImageUploadController);

    wysiwygImageUploadController.$inject = [
        'UploadsApi'
    ];

    function wysiwygImageUploadController(
        UploadsApi
    ) {
        var vm = this;
        // properties (ngInit in template adds vm.editorName)
        vm.imageFile = null;
        vm.isLoading = false;
        vm.isLoadingProgress = 0;
        vm.uploadOptions = {
            resize: false,
            resizeSize: {
                w: 450,
                h: 200
            },
            resizeShape: 'rectangle',
            resizeAspectRatio: 2.25
        };

        // methods
        vm.close = close;
        vm.handleImage = handleImage;

        /**
         * Closes the wysiwyg image upload form by returning no src
         * @return {void}
         */
        function close() {
            window.editorImageUploadComplete(vm.editorName, null);
        }

        /**
         * Callback for the dropImage directive.
         * Uploads image and sends src to the wygiwyg controller
         * @param  {img} img - base64 image
         * @return {void}
         */
        function handleImage(img) {
            if (img) {
                vm.isLoading = true;

                // !TODO change path dynamically based on the item we're adding this image to
                UploadsApi.uploadImage(img, 'user')
                    .then(function handleWysiwygImageResponse(response) {
                        vm.isLoading = false;
                        vm.isLoadingProgress = 0;
                        window.editorImageUploadComplete(vm.editorName, response.src);
                    }, function handleWysiwygImageError(err) {
                        vm.isLoading = false;
                        vm.isLoadingProgress = 0;
                    }, function handleWysiwygImageProgress(progressPercent) {
                        vm.isLoadingProgress = progressPercent;
                    });
            }
        }
    }

}(window, angular));
